import { normalizePermissions } from "./normalizePermissions";

const hasPermissionInList = (permissions, accessRole) => {
  if (!Array.isArray(permissions)) return false;
  const target = String(accessRole).toLowerCase();
  return permissions.some((a) => String(a?.id).toLowerCase() === target);
};

const CheckPermission = (accessRole) => {
  try {
    const userInfoRaw = localStorage.getItem("userInfo");
    if (userInfoRaw) {
      const userInfo = JSON.parse(userInfoRaw);
      if (userInfo?.role?.name === "super-admin") return true;
    }
  } catch (e) {
    void e;
  }

  try {
    const fromLocal = JSON.parse(localStorage.getItem("permissions"));
    if (hasPermissionInList(fromLocal, accessRole)) return true;
  } catch (e) {
    void e;
  }

  try {
    const userInfoRaw = localStorage.getItem("userInfo");
    if (userInfoRaw) {
      const userInfo = JSON.parse(userInfoRaw);
      const normalized = normalizePermissions(userInfo?.role?.permissions);
      if (hasPermissionInList(normalized, accessRole)) return true;
    }
  } catch (e) {
    void e;
  }

  return false;
};

export default CheckPermission;
